// extracted by mini-css-extract-plugin
export default {"outletContainer":"DashboardOutlet_outletContainer__O7uCj"};